import * as React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import * as PatientStore from '../../../app/store/PatientStore';

const LoadPatientProgram = ({ patientId, patientProgramId }) => {
    const { patientId: patientIdFromUrl, patientProgramId: patientProgramIdFromUrl } = useParams();
    const dispatch = useDispatch();

    const pId = patientId || patientIdFromUrl;
    const ppId = patientProgramId || patientProgramIdFromUrl;

    const hasLoadedPatient = useSelector(state => Boolean(pId && state.patient.details && state.patient.details[pId]));
    const isLoading = useSelector(state => Boolean(state.patient.requests[`${PatientStore.PATIENT_PROGRAM_DETAILS_RECIEVED}/${ppId}`]
        && (state.patient.requests[`${PatientStore.PATIENT_PROGRAM_DETAILS_RECIEVED}/${ppId}`].loading
            || state.patient.requests[`${PatientStore.PATIENT_PROGRAM_DETAILS_RECIEVED}/${ppId}`].completed)));

    const hasLoaded = useSelector((state) => {
        const patientProgramData = state.patient.details && state.patient.details[pId] && state.patient.details[pId].programs
            && state.patient.details[pId].programs[ppId];

        return patientProgramData && !patientProgramData.limitedDetails;
    });

    React.useEffect(() => {
        if (hasLoadedPatient && ppId && !isLoading && !hasLoaded) {
            dispatch(PatientStore.actionCreators.getPatientProgram(ppId, { reducerParams: { patientId: pId } }));
        }
    }, [dispatch, hasLoaded, hasLoadedPatient, isLoading, pId, ppId]);

    return null;
};

LoadPatientProgram.propTypes = {
    patientProgramId: PropTypes.string,
    patientId: PropTypes.string,
};

export default LoadPatientProgram;
